import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Footer, Notification, GoogleAnalytics, HelpContainer } from '@ctsu/react-ctsu-ui';
import { withAppContext, getToken } from '@ctsu/loader';
import { NavSpine } from '@ctsu/nav-spine';
import { Grid, Paper } from '@material-ui/core';
import { StickyContainer } from 'react-sticky';
import { compose } from 'recompose';
import Elements from 'ctsutheme/components/atoms';
import molecules from 'ctsutheme/components/molecules';
import { RenderElement } from 'components/RenderHelpers';
import { InitAppSession } from 'components';
import { getGAId } from 'helpers';
import HeaderComponent from './Header';
import buildInfo from '../build_info/build_info-lock.json';

const { Typography } = Elements;
const { Card } = molecules;

const styles = theme => ({
  root: {
    padding: 8,
    margin: 'auto'
  }
});

const layout = props => {
  const { context, classes, children } = props;
  const { application, session } = context;
  return (
    <>
      <StickyContainer>
        <div>
          <RenderElement access>
            <NavSpine
              userContext={session}
              appName="PROTOCOL"
              appRoot={`${process.env.REACT_APP_ORIGIN}`}
              getToken={getToken}
            />
            <div>
              <HelpContainer
                appName="PROTOCOL"
                getToken={getToken}
                appUrl={process.env.REACT_APP_ORIGIN}
              />
            </div>
            <GoogleAnalytics application={process.env.REACT_APP_NAME} gaTrackingId={getGAId()} />
            <InitAppSession session={session} application={application} />
          </RenderElement>
          <RenderElement access>
            <div id="skip">
              <a href="#main-content">Skip to Main Content</a>
            </div>
            <HeaderComponent session={session} />
            <Notification
              fnToken={getToken}
              appName={application.appName}
              isMaintainer
              coreVersion="v1"
              appContext={context}
              isPublic
            />
          </RenderElement>
          <main id="main-content" tabIndex="-1" />
          <RenderElement access>
            <Paper
              className={`${classes.root} app-spacing app-body`}
              style={{ backgroundColor: 'transparent', minHeight: '80vh' }}
              elevation={0}
            >
              {children}
            </Paper>
          </RenderElement>
          <main id="footer" tabIndex="-1" />
          <div id="skip">
            <a href="#main-content">Skip to Main Content</a>
          </div>
          <RenderElement access>
            <Footer
              buildInfo={{
                buildVersion: buildInfo.build_version,
                buildDate: buildInfo.build_date
              }}
              releaseNotes="https://www.ctsu.org/Master/SimplePage.aspx?ckey=PROT-RELEASE-NOTES"
              dbName={application.dbName}
            />
          </RenderElement>
        </div>
      </StickyContainer>
    </>
  );
};

const styles1 = theme => ({
  root: {
    flexGrow: 1
  },
  loginCard: {
    padding: theme.spacing(5),
    maxWidth: 600,
    maxHeight: 600
  }
});

const loginHolder = ({ children, classes }) => (
  <div className={classes.root}>
    <Grid
      container
      direction="row"
      justify="center"
      spacing={4}
      style={{ alignItems: 'flex-start' }}
    >
      <Grid item xs={10} className="d-flex bg-white shadow-sm p-4 my-4">
        <Grid item xs={6} className="d-flex align-items-center mr-4">
          <div>
            <Typography data-id="welcomeText" variant="h4" color="primary" align="left" className="mb-3 color-blue">
              Welcome
            </Typography>
            <Typography
              variant="h6"
              color="primary"
              data-id="welcomeContent"
              align="left"
              className="color-dark-grey font-normal"
            >
              The
              <span style={{ fontWeight: '700' }}> Protocols </span>
              application displays
              <span style={{ fontWeight: '700' }}> protocol/study data, including statuses, versions, countries and network participation, study agents, PSRs, CIRB information, and OPEN/Website and TRIAD configuration settings for clinical trials </span>
              across NCI-supported research networks.
              LPO and CTSU staff with appropriate privileges are able
              <span style={{ fontWeight: '700' }}> to manage specific protocol data in this application.</span>
            </Typography>
          </div>
        </Grid>
        <Grid xs={6} item>
          <Card className={`${classes.loginCard} login-card-box`} elevation={0}>
            <div>
              <div
                title="CTEP-IAM Login"
                className="login-card-title"
              >
                CTEP-IAM Login
              </div>
              {children}
            </div>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  </div>
);
export const LoginHolder = withStyles(styles1)(loginHolder);

const Layout = compose(withAppContext)(layout);

export default withStyles(styles)(Layout);
